/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2023-2024. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: SwalConfig.ts
 * Created by: ChanYing
 * Create Date: 2024-09-03 10:32
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import CheckUtil from "@/commons/utils/CheckUtil";

export default class SwalConfig {
    public imageUrl: string;
    public title: string;
    public html: string;
    public confirmButtonText: string;
    public showCancelButton: boolean;
    public cancelButtonText: string;
    public showCloseButton: boolean;
    public destructive: boolean;

    public static errorInfo(title: string, html: string, confirmButtonText: string) {
        let config = new SwalConfig();
        config.imageUrl = require("@/assets/images/icon-png/delete-with-circle-danger.svg");
        config.title = title;
        config.html = html;
        config.confirmButtonText = confirmButtonText;
        config.showCancelButton = false;
        config.cancelButtonText = "";
        config.showCloseButton = false;
        return config;
    }

    public static successInfo(title: string, html: string, confirmButtonText: string) {
        let config = new SwalConfig();
        config.imageUrl = require("@/assets/images/icon-png/tick-with-circle-enable.svg");
        config.title = title;
        config.html = html;
        config.confirmButtonText = confirmButtonText;
        config.showCancelButton = false;
        config.cancelButtonText = "";
        config.showCloseButton = false;
        return config;
    }


    public static warnInfo(title: string, html: string, confirmButtonText: string, cancelButtonText: string) {
        let config = new SwalConfig();
        config.imageUrl = require("@/assets/images/icon-png/alert.svg");
        config.title = title;
        config.html = html;
        config.confirmButtonText = confirmButtonText;
        if (CheckUtil.isNotEmpty(cancelButtonText)) {
            config.showCancelButton = true;
            config.cancelButtonText = cancelButtonText;
            config.destructive = true;
        }
        config.showCloseButton = false;
        return config;
    }

    public static promptInfo(title: string, html: string, confirmButtonText: string) {
        let config = new SwalConfig();
        config.imageUrl = require("@/assets/images/icon-png/alert.svg");
        config.title = title;
        config.html = html;
        config.confirmButtonText = confirmButtonText;
        config.showCancelButton = false;
        config.cancelButtonText = "";
        config.showCloseButton = false;
        return config;
    }

    public static customInfo(imageUrl: string, title: string, html: string, confirmButtonText: string
        , showCancelButton: boolean, cancelButtonText: string, showCloseButton: boolean
    ) {
        let config = new SwalConfig();
        config.imageUrl = imageUrl;
        config.title = title;
        config.html = html;
        config.confirmButtonText = confirmButtonText;
        config.showCancelButton = showCancelButton;
        config.cancelButtonText = cancelButtonText;
        config.showCloseButton = showCloseButton;
        return config;
    }

    constructor() {
        this.imageUrl = "";
        this.title = "";
        this.html = "";
        this.confirmButtonText = "";
        this.showCancelButton = false;
        this.cancelButtonText = "";
        this.showCloseButton = false;
        this.destructive = false;
    }
}